import { isTwitchChannelEvent } from './twitch.js';
import { isKofiEvent } from './kofi.js';
import { isShopEvent, type ShopRedemptionEvent } from './shop.js';
import type {
  ChannelFollowEvent,
  ChannelSubscribeEvent,
  ChannelResubEvent,
  ChannelGiftSubEvent,
  ChannelSubGiftRecipientEvent,
  ChannelCheerEvent,
  ChannelRedemptionEvent,
  ChannelRaidEvent,
  ChannelViewerMilestoneEvent,
  ChannelModeChangeEvent,
  ChannelAnnouncementEvent,
  ChannelSubShareEvent,
} from './twitch.js';
import type { KofiDonationEvent, KofiSubscriptionEvent } from './kofi.js';

export type ChannelEvent =
  | ChannelFollowEvent
  | ChannelSubscribeEvent
  | ChannelResubEvent
  | ChannelGiftSubEvent
  | ChannelSubGiftRecipientEvent
  | ChannelCheerEvent
  | ChannelRedemptionEvent
  | ChannelRaidEvent
  | ChannelViewerMilestoneEvent
  | ChannelModeChangeEvent
  | ChannelAnnouncementEvent
  | ChannelSubShareEvent
  | KofiDonationEvent
  | KofiSubscriptionEvent
  | ShopRedemptionEvent;

/** Type guard: is this a channel event (Twitch EventSub, Ko-fi or Shop)? */
export function isChannelEvent(value: unknown): value is ChannelEvent {
  return isTwitchChannelEvent(value) || isKofiEvent(value) || isShopEvent(value);
}
